<template>
  <v-dialog scrollable
    v-model="config.status.active"
    width="300">
    <v-card class="grey lighten-4">
      <v-card-title class="primary">ファイルの移動</v-card-title>
      <v-card-text class="transparency px-4 pb-0">
        <v-row dense align="center">
          <v-form ref="form" lazy-validation>
            <v-col cols="12" class="d-flex justify-center align-baseline text-center py-2">
              <v-icon small class="mr-2">fal fa-file-excel</v-icon>
              <span class="caption">{{ printTargetFile }}</span>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-baseline text-center py-2">
              <v-icon small class="mr-2">fa-folder</v-icon>
              <span>{{ printCurrentFolder }}</span>
            </v-col>
            <v-col cols="12" class="text-center py-2">
              <v-icon color="primary">fal fa-arrow-down</v-icon>
            </v-col>
            <v-col cols="12" class="py-2">
              <v-select solo flat outlined
                v-model="form.mid"
                color="secondary"
                prepend-inner-icon="fa-folder"
                :items="getDestItems"
                :rules="rules.required"
              />
            </v-col>
            <v-subheader class="pl-0">店舗</v-subheader>
            <v-divider></v-divider>
            <v-col cols="12" class="py-2">
              <v-chip-group column mandatory
                active-class="secondary white--text"
                v-model="form.tag">
                <v-chip
                  v-for="item in getOfficeItems"
                  :key="`tag_content_${item.value}`"
                  :value="item.value"
                  :rules="rules.required">{{ item.text }}</v-chip>
              </v-chip-group>
            </v-col>
          </v-form>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          :loading="isLoading"
          @click="move">移動する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'authorBbookMove',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      store: {
        file: {},
        folders: [],
        current: ''
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        mid: '',
        tag: ''
      }
    }
  },
  methods: {
    open: function (req) {
      const { file, item, items } = req || {}
      this.$set(this.store, 'file', file || {})
      this.$set(this.store, 'current', item || { id: '' })
      this.$set(this.store, 'folders', items || [])
      this.$set(this.form, 'mid', '')
      this.$set(this.form, 'tag', file.tags.join(','))
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    done: function () {
      this.$emit('done')
      this.close()
    },
    move: function () {
      this.submit({ type: 'move' })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id } = this.store.item || {}
      const { file } = this.store
      const { mid, tag } = this.form
      const urls = {
        move: `${this.$url.api}/box/move/${mid}`
      }
      const fds = {
        move: { items: [ file ], tags: [ tag ] }
      }
      if (type && urls[type] && fds[type]) {
        if (type !== 'move' || !this.$refs.form.validate()) {
          return false
        }
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, submitType) {
      const type = submitType || ''
      if (type === 'move') {
        this.$set(this.config.status, 'loading', false)
        this.done()
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    printCurrentFolder () {
      return this.store.current.name || ''
    },
    printTargetFile () {
      return this.store.file.name || ''
    },
    getDestItems () {
      return this.store.folders.length ? this.store.folders.filter(it => { return it.id !== this.store.current.id }).map(it => {
        return {
          text: it.name,
          value: it.id
        }
      }).sort((a, b) => {
        return a.text > b.text ? -1 : 1
      }) : []
    },
    getOfficeItems () {
      return Object.keys(this.$mango.areaSlugs).map(tag => {
        return {
          text: this.$mango.areaSlugs[tag],
          value: tag
        }
      })
    }
  }
}
</script>